define('rebrush/components/checkout/password/onpage-validator',[
    'lodash',
    'jquery',
    'cartware_checkout',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    _,
    $,
    CartwareCheckout,
    Component,
    BEM
) {
    var $document = $(document.body);

    return Component.create({
        registrationBlock:	null,
        rules: [
            {
                pattern: '[A-Z]',
                target: 'password-hint-upperCase'
            },
            {
                pattern: '[a-z]',
                target: 'password-hint-lowerCase'
            },
            {
                pattern: '[0-9]',
                target: 'password-hint-numericChar'
            },
            {
                pattern: '[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]',
                target: 'password-hint-specialChar'
            }
        ],

        $init: function() {
            this.registrationBlock = BEM.block('checkout-account-registration-form');
            this.bindEvents();
        },

        bindEvents: function() {
            $document.on('keyup', '.' + BEM.buildElementClassname('checkout-account-registration-form', 'password-input'),
                _.bind(this.validatePassword, this));
        },

        validatePassword: function() {
            var passwordInput = $('.' + BEM.buildElementClassname('checkout-account-registration-form', 'password-input')),
                password = passwordInput.val(),
                hintLength = $('.password-hint-length'),
                hintNames = $('.password-hint-noNames'),
                firstName = $('input[name="shipping[firstname]"]').val(),
                lastName = $('input[name="shipping[lastname]"]').val(),
                self = this,
                hasError = false;

            if (firstName || lastName) {
                var namesPattern = '^((?!' + (firstName || '') + (firstName && lastName ? '|' : '') + (lastName || '') + ').)*$';
                if (new RegExp(namesPattern).test(password)) {
                    self.toggleValidationHint(hintNames, 'success');
                } else {
                    self.toggleValidationHint(hintNames, 'error');
                    hasError = true;
                }
            }


            if (password.length >= 8) {
                this.toggleValidationHint(hintLength, 'success');
            } else {
                this.toggleValidationHint(hintLength, 'error');
                hasError = true;
            }

            this.rules.each(function(e) {
                var target = $('.' + e.target);
                if (new RegExp(e.pattern).test(password)) {
                    self.toggleValidationHint(target, 'success');
                } else {
                    self.toggleValidationHint(target, 'error');
                    hasError = true;
                }
            });

            if (password.length && hasError) {
                passwordInput.removeClass('validation-passed');
                passwordInput.addClass('validation-failed');
            } else {
                passwordInput.addClass('validation-passed');
                passwordInput.removeClass('validation-failed');
            }

            this.toggleConfirmPasswordContainer(password);
        },

        toggleValidationHint: function(e, state) {
            var icon = e.find('i:first');
            switch (state) {
                case 'success':
                    if (e.bemHasModifier('red')) {
                        e.bemRemoveModifier('red').bemAddModifier('green');
                    }
                    if (icon.hasClass('icon-message-error')) {
                        icon.removeClass('icon-message-error').addClass('icon-added-to-cart-check');
                    }
                    break;
                case 'error':
                    if (e.bemHasModifier('green')) {
                        e.bemRemoveModifier('green').bemAddModifier('red');
                    }
                    if (icon.hasClass('icon-added-to-cart-check')) {
                        icon.removeClass('icon-added-to-cart-check').addClass('icon-message-error');
                    }
                    break;
            }
        },

        toggleConfirmPasswordContainer: function(password) {
            var containerPasswordConfirm = $('.' + BEM.buildElementClassname('checkout-account-registration-form', 'confirm-password-container')),
                inputPasswordConfirm = $('input[name="register[password_confirm]"]'),
                inputCaptcha = $('input[name="captcha[code]"]'),
                inputPrivacyPolicyAgreement = $('input[data-agreement-code="has_accepted_privacy_policy"]');

            if (password.length > 0) {
                if (containerPasswordConfirm.hasClass('hidden')) {
                    containerPasswordConfirm.removeClass('hidden');
                }
                if (!inputPasswordConfirm.hasClass('validate-cpassword')) {
                    inputPasswordConfirm.addClass('validate-cpassword');
                }
                if (!inputCaptcha.hasClass('required-entry')) {
                    inputCaptcha.addClass('required-entry');
                }
                if (!inputPrivacyPolicyAgreement.hasClass('required-entry')) {
                    inputPrivacyPolicyAgreement.addClass('required-entry');
                }
            } else {
                if (!containerPasswordConfirm.hasClass('hidden')) {
                    containerPasswordConfirm.addClass('hidden');
                }
                if (inputPasswordConfirm.hasClass('validate-cpassword')) {
                    inputPasswordConfirm.removeClass('validate-cpassword');
                }
                if (inputCaptcha.hasClass('required-entry')) {
                    inputCaptcha.removeClass('required-entry');
                }
                if (inputPrivacyPolicyAgreement.hasClass('required-entry')) {
                    inputPrivacyPolicyAgreement.removeClass('required-entry');
                }
            }
        },
    });
});

